<template>
  <div class="home_doctor">
    <div class="row justify-content-md-center">
      <div class="col-md-12">
        <reporting-list></reporting-list>
      </div>
      <!--
      <div class="col-md-4">
        <div class="row">
          <div class="col-md-6">
          </div>
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
  import ReportingList from './components/ReportingList.vue'

  export default {
    data () {
      return {
        //
      }
    },
    components: {
      ReportingList
    },
    methods: {
    },
    beforeMount () {
      //
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Reporting/Reporting.vue?7e4741b4